import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { ReducerState } from '../../../store.types';

export const csvTemplatesSelector = ({ csvTemplates }: ReducerState) => csvTemplates;

export const csvTemplatesLoadingSelector = createSelector(
  csvTemplatesSelector,
  ({ fetchCsvTemplatesStatus }) => fetchCsvTemplatesStatus === fetchStatuses.pending,
);

export const csvTemplateLoadingSelector = createSelector(
  csvTemplatesSelector,
  ({ fetchCsvTemplateStatus }) => fetchCsvTemplateStatus === fetchStatuses.pending,
);

export const csvTemplatesErrorSelector = createSelector(csvTemplatesSelector, ({ error }) => error);

export const selectedCsvTemplateSelector = createSelector(
  csvTemplatesSelector,
  ({ selectedCsvTemplate }) => selectedCsvTemplate,
);

export const csvTemplateNameOptionsSelector = createSelector(
  csvTemplatesSelector,
  ({ csvTemplateNameOptions }) => csvTemplateNameOptions,
);

export const csvTemplateNameOptionsLoadingSelector = createSelector(
  csvTemplatesSelector,
  ({ fetchCsvTemplateNameOptionsStatus }) => fetchCsvTemplateNameOptionsStatus === fetchStatuses.pending,
);

export const createCsvTemplateLoadingSelector = createSelector(
  csvTemplatesSelector,
  ({ createCsvTemplateStatus }) => createCsvTemplateStatus === fetchStatuses.pending,
);

export const updateCsvTemplateLoadingSelector = createSelector(
  csvTemplatesSelector,
  ({ updateCsvTemplateStatus }) => updateCsvTemplateStatus === fetchStatuses.pending,
);

export const deleteCsvTemplateLoadingSelector = createSelector(
  csvTemplatesSelector,
  ({ deleteCsvTemplateStatus }) => deleteCsvTemplateStatus === fetchStatuses.pending,
);

export {};
